import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as subrecipients from '../../../../subrecipients'
import * as subaward from '../subaward'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: subaward.RESOURCE.payload.dimension.partialId,
      partialId: subaward.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Institution that is receiving this subaward',
    isOptional: false,
    name: 'Subrecipient',
    partialId: PartialId.Standard.create('subrecip'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        subrecipients.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
